"use strict";

/*
  Filters:
  - Vendors (checkboxes inside .js-vendors) -> matches data-vendor
  - Van tags (checkboxes inside .js-vans) -> matches data-tags pipe list

  Logic:
  - OR within each group
  - AND between groups
*/

function getCheckedValues(scope, selector) {
  return Array.from(scope.querySelectorAll(selector))
    .filter((el) => el.checked)
    .map((el) => (el.value || "").trim())
    .filter(Boolean);
}

function itemMatchesAny(values, haystackArray) {
  if (!values || values.length === 0) return true;
  return values.some((v) => haystackArray.includes(v));
}

function applyFilters(root) {
  if (!root) return;

  const vendorFilters = getCheckedValues(
    root,
    ".js-vendors input[type='checkbox']"
  );
  const vanFilters = getCheckedValues(
    root,
    ".js-vans input[type='checkbox']"
  );

  const grid = root.querySelector("#shuffle-container");
  if (!grid) return;

  const items = Array.from(grid.querySelectorAll(".grid__item"));

  items.forEach((item) => {
    const vendor = (item.getAttribute("data-vendor") || "").trim();
    const tagsRaw = (item.getAttribute("data-tags") || "").trim();
    const tags = tagsRaw ? tagsRaw.split("|").map((t) => t.trim()) : [];

    const passVendors = itemMatchesAny(vendorFilters, [vendor]);
    const passVans = itemMatchesAny(vanFilters, tags);
    const show = passVendors && passVans;

    item.classList.toggle("is-filter-hidden", !show);
  });
}

function initAllProductsFilters(root) {
  if (!root || root.dataset.filtersInitialized === "true") return;

  root.dataset.filtersInitialized = "true";

  root
    .querySelectorAll(
      ".js-vendors input[type='checkbox'], .js-vans input[type='checkbox']"
    )
    .forEach((cb) => {
      cb.addEventListener("change", function () {
        applyFilters(root);
      });
    });

  applyFilters(root);
}

document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll("[data-aw-all-products]")
    .forEach((root) => initAllProductsFilters(root));
});

window.addEventListener("aw:productsAppended", function () {
  document
    .querySelectorAll("[data-aw-all-products]")
    .forEach((root) => applyFilters(root));
});